import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PublicService } from '../public.service';

@Component({
  selector: 'app-six-digit',
  templateUrl: './six-digit.component.html',
  styleUrls: ['./six-digit.component.scss']
})
export class SixDigitComponent implements OnInit {

  time = 120;
  key = "deactive";
  key2 = "active";
  key3 = "deactive";

  constructor(public publicservice: PublicService, public router: Router) {
    setInterval(() => this.time = this.time - 1, 1000);
    this.publicservice.PhoneNumberAgain = localStorage.getItem('phoneDriver')!;
   
    // console.log( publicservice.token);
    // console.log(publicservice.logedIn);
    if(publicservice.logedIn == "true" && localStorage.getItem("goToSigninPage") == "false"){
      this.router.navigate(['home']);
    }
    if(publicservice.logedIn == "true" && localStorage.getItem("goToSigninPage") == "true"){
      this.router.navigate(['signin']);
    }
    
    
  }

  ngOnInit(): void {
  }



  onDigitInput(event: any) {

    let element;
    if (event.code !== 'Backspace')
      element = event.srcElement.nextElementSibling;

    if (event.code === 'Backspace')
      element = event.srcElement.previousElementSibling;

    if (element == null)
      return;
    else
      element.focus();
  }


  getMinute() {
    if (this.time <= 0) {
      return "00";
    }
    if ((this.time / 60) % 60 < 10) {
      return "0" + parseInt((this.time / 60) % 60 + "");
    }
    return parseInt((this.time / 60) % 60 + "");
  }
  getSecond() {
    if (this.time <= 0) {
      this.key = "active";
      this.key2 = "deactive";
      return "00";
    }
    if (this.time % 121 < 10) {
      return "0" + this.time % 121;
    }
    return this.time % 121;
  }


  sendAgainClick() {
    this.publicservice.PhoneNumberAgain = localStorage.getItem('phoneKarbar')!;
    // console.log(this.phoneNumberAgain);
    
    this.publicservice.login2().then(r => {
      if ( r.message == "successful" ){
      // alert("okkkkkk");
      }
      if ( r.message == "failure" ){
       alert("با عرض پوزش سرویس اس ام اس به صورت موقتی از دسترس خارج شده است. برای اطلاعات بیشتر با شماره 09122222222 تماس بگیرید");
        }
    });
  
  }


  sixdigit() {
    let a = localStorage.getItem("aKarbar");

    if (a == "true") {
      this.publicservice.sixdigit2().then(r => {
        localStorage.setItem('token', r.token);
        if (r.data == "code has not been approved") {
          this.key3 = "active";
        }
        if (r.redirect == "register") {
          localStorage.setItem("aKarbar" , "false");
          localStorage.setItem("goToSigninPage", "true");
          this.router.navigate(['signin']);
        }
        if (r.redirect == "main") {
          localStorage.setItem("aKarbar" , "false");
          localStorage.setItem("goToSigninPage", "false");
          this.router.navigate(['home']);
        }
      });
    }
    else {
      this.publicservice.sixdigit().then(r => {
        localStorage.setItem('token', r.token);
        if (r.data == "code has not been approved") {
          this.key3 = "active";
        }
        if (r.redirect == "register") {
          localStorage.setItem("aKarbar" , "false");
          localStorage.setItem("goToSigninPage", "true");
          this.router.navigate(['signin']);
        }
        if (r.redirect == "main") {
          localStorage.setItem("aKarbar" , "false");
          localStorage.setItem("goToSigninPage", "false");
          this.router.navigate(['home']);
        }
      });

    }

  }

  onChange(UpdatedValue: string): void {
    let a = localStorage.getItem("aKarbar");

    if (a == "true") {
      this.publicservice.sixdigit2().then(r => {
        localStorage.setItem('token', r.token);
        if (r.data == "code has not been approved") {
          this.key3 = "active";
        }
        if (r.redirect == "register") {
          localStorage.setItem("aKarbar" , "false");
          localStorage.setItem("goToSigninPage", "true");
          this.router.navigate(['signin']);
        }
        if (r.redirect == "main") {
          localStorage.setItem("aKarbar" , "false");
          localStorage.setItem("goToSigninPage", "false");
          this.router.navigate(['home']);
        }
      });
    }
    else {
      this.publicservice.sixdigit().then(r => {
        localStorage.setItem('token', r.token);
        if (r.data == "code has not been approved") {
          this.key3 = "active";
        }
        if (r.redirect == "register") {
          localStorage.setItem("aKarbar" , "false");
          localStorage.setItem("goToSigninPage", "true");
          this.router.navigate(['signin']);
        }
        if (r.redirect == "main") {
          localStorage.setItem("aKarbar" , "false");
          localStorage.setItem("goToSigninPage", "false");
          this.router.navigate(['home']);
        }
      });

    }

  }


  taqirClick() {
    localStorage.setItem("logedInWaste", "false");
    this.router.navigate(['login']);
  }
  

}
